import { ClientSession } from '~ng-common-lib/session/session.type';

import { ClientUser } from '../types/user';

export function userClientToSessionClientTransformer(user: ClientUser): ClientSession | null {
	if (!user) {
		return null;
	}

	const session: ClientSession = {
		userId: user?.id,
		email: user?.email,
		featureFlags: user?.featureFlags,
		adminRole: user?.adminLevel,
	};

	return session;
}
